export default __webpack_public_path__ + "static/msgs-4b6c43caf55c37249096f7360d878f48.jpg";